export { default as DataTable } from "./DataTable";
export { default as createColumn } from "./createColumn";
export { default as TableQ } from "./TableQ";
export { default as TablePages } from "./TablePages";
export { default as TablePosition } from "./TablePosition";



// WEBPACK FOOTER //
// ./src/components/common/DataTable/index.js